import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import PreLoader from '../Others/PreLoader';
import { GET, POST } from '../../utils/HttpRequests';

const Refund = () => {
  const appUrl = process.env.REACT_APP_API_URL;
  const ApiUrl = process.env.REACT_APP_WEB_API_URL;
  const refundStatuses = ['All', 'inprogress', 'processed', 'completed'];
  const [Users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('All');

  const filterDropdown = (
    <select
      onChange={(e) => setFilterStatus(e.target.value)}
      style={{ width: '200px', height: '40px', fontSize: '16px' }}
    >
      {refundStatuses.map((status) => (
        <option key={status} value={status}>
          {status}
        </option>
      ))}
    </select>
  );

  const getRefundRequestedUsers = async () => {
    try {
      setLoading(true);
      const URL = `${appUrl}admin/console/refund-requested-users`;
      const Res = await GET(URL);
      const AllUsers = Res?.data?.response?.users;
      const filteredUsers = AllUsers.filter((user) => filterStatus === 'All' || user.refundDetails.refundStatus === filterStatus);
      setUsers(filteredUsers);
      setLoading(false);
    } catch (err) {
      // console.error(err.message);
      setLoading(false);
      toast.error('Something went wrong');
    }
  };
  const sendRefundApproval = async (user) => {
    setLoading(true);
    const refundUrl = `${ApiUrl}v1/internal/w/doosra-refund`;
    const result = await POST(refundUrl, { user_id: user.user_id });
    if (result?.data?.success === true) {
      toast.success('Refund Request Sent');
      setLoading(false);
    }
    setLoading(false);
    await getRefundRequestedUsers();
  };

  useEffect(() => { getRefundRequestedUsers(); }, [filterStatus]);

  const displayData = (
    <td colSpan="7"><p style={{ textAlign: 'center' }}> No Records Found </p></td>
  );
  const UsersHTML = Users && Users.length > 0 ? Users.map((user) => (
    <>
      <tr key={Math.random()}>
        <td title={user.user_id}>{user.user_id || '-'}</td>
        <td title={user.refundDetails.emailid}>{user.refundDetails.emailId || '-'}</td>
        <td title={user.refundDetails.upiId}>{user.refundDetails.upiId || '-'}</td>
        <td title={user.refundDetails.totalRefundAmount}>{user.refundDetails.totalRefundAmount || '-'}</td>
        <td title={user.refundDetails.planRefundAmount}>{user.refundDetails.planRefundAmount || '-'}</td>
        <td title={user.refundDetails.customVmnRefundAmount}>{user.refundDetails.customVmnRefundAmount || '-'}</td>
        <td title={user.refundDetails.refundStatus}>{user.refundDetails.refundStatus || '-'}</td>
        <td title={user.refundDetails.initiatedAt}>{moment(user.refundDetails.initiatedAt).format('YYYY-MM-DD hh:mm:ss A') || '-'}</td>
        <td
          title={user.user_id}
        >
          {user.refundDetails.refundStatus === 'inprogress' ? (
            <Button
              variant="danger"
              onClick={() => sendRefundApproval(user)}
              className="inputs-fl-1"
              size="sm"
              style={{ marginRight: '5%' }}
            >
              Refund
            </Button>
          ) : '-' }
        </td>
      </tr>
    </>
  ))
    : (
      <tr>
        {displayData}
      </tr>
    );

  return (
    <div style={{
      display: 'flex', padding: '1%', justifyContent: 'space-between', flexWrap: 'wrap', boxShadow: 'none',
    }}
    >
      {filterDropdown}
      <div style={{ flexBasis: '100%' }}>
        <>
          <div>
            <center>
              <h4>
                Total(Refund Users):
                &nbsp;
                {' '}
                {Users.length}
              </h4>
            </center>
          </div>
          <div className="table-responsive bn">
            <table className="table">
              <thead className="thad-dark">
                <tr style={{ textTransform: 'capitalize' }}>
                  <th>User Id</th>
                  <th>Email</th>
                  <th>UPI Id</th>
                  <th>Refund Amount</th>
                  <th>Plan Amount</th>
                  <th>VMN Amount</th>
                  <th>Refund Status</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              {
                loading ? <PreLoader />
                  : (
                    <tbody>
                      {UsersHTML}
                    </tbody>
                  )
              }
            </table>
          </div>
        </>
      </div>
    </div>
  );
};

export default Refund;
